export interface FloorPlanPreviewRect {
  left: number;
  top: number;
  width: number;
  height: number;
}

export interface FloorPlanPreviewPan {
  x: number;
  y: number;
}

export function getContainedImageRect(containerWidth: number, containerHeight: number, imageWidth: number, imageHeight: number): FloorPlanPreviewRect {
  if (![containerWidth, containerHeight, imageWidth, imageHeight].every((value) => Number.isFinite(value) && value > 0)) {
    return { left: 0, top: 0, width: 0, height: 0 };
  }
  const scale = Math.min(containerWidth / imageWidth, containerHeight / imageHeight);
  const width = imageWidth * scale;
  const height = imageHeight * scale;
  return {
    left: (containerWidth - width) / 2,
    top: (containerHeight - height) / 2,
    width,
    height,
  };
}

export function clampPreviewPan(pan: FloorPlanPreviewPan, containerWidth: number, containerHeight: number, imageRect: FloorPlanPreviewRect, zoom: number): FloorPlanPreviewPan {
  const safeZoom = Math.max(1, zoom);
  const maxX = Math.max(0, (imageRect.width * safeZoom - containerWidth) / 2);
  const maxY = Math.max(0, (imageRect.height * safeZoom - containerHeight) / 2);
  return {
    x: Math.max(-maxX, Math.min(maxX, pan.x)),
    y: Math.max(-maxY, Math.min(maxY, pan.y)),
  };
}

export function mapPreviewPointToImage(viewportX: number, viewportY: number, imageRect: FloorPlanPreviewRect, zoom: number, pan: FloorPlanPreviewPan): { x: number; y: number } {
  if (imageRect.width <= 0 || imageRect.height <= 0) return { x: 0, y: 0 };
  const safeZoom = Math.max(1, zoom);
  const centerX = imageRect.left + imageRect.width / 2;
  const centerY = imageRect.top + imageRect.height / 2;
  const imageX = ((viewportX - pan.x - centerX) / safeZoom + centerX - imageRect.left) / imageRect.width;
  const imageY = ((viewportY - pan.y - centerY) / safeZoom + centerY - imageRect.top) / imageRect.height;
  return {
    x: Math.max(0, Math.min(1, imageX)),
    y: Math.max(0, Math.min(1, imageY)),
  };
}
